import React from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, Typography } from '@mui/material'
import { t } from 'i18next'

const T = 'YAPPY_PAYMENT_T'

function PaymentInfoCard({ paymentData, phoneError, onPhoneChange }) {
  return (
    <Box className="yappy-info-box">
      <Typography className="yappy-info-title">
        {t(`${T}.PAYMENT_INFO_TITLE`)}
      </Typography>
      <Divider sx={{ my: 1.5 }} />

      <Box className="yappy-info-grid">
        <Box>
          <Typography className="yappy-field-label">
            {t(`${T}.CUSTOMER_LABEL`)}
          </Typography>
          <Typography className="yappy-field-value">
            {paymentData.customerName}
          </Typography>
        </Box>
        {paymentData.email && (
          <Box>
            <Typography className="yappy-field-label">
              {t(`${T}.EMAIL_LABEL`)}
            </Typography>
            <Typography className="yappy-field-value">
              {paymentData.email}
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography className="yappy-field-label" sx={{ mb: 0.75 }}>
          {t(`${T}.PHONE_LABEL`)}
        </Typography>
        <input
          type="text"
          inputMode="numeric"
          value={paymentData.phone || ''}
          onChange={e => onPhoneChange(e.target.value.replace(/\D/g, ''))}
          className="yappy-phone-input"
          maxLength={8}
          style={phoneError ? { borderColor: '#d32f2f' } : undefined}
        />
        {phoneError && (
          <Typography
            variant="body2"
            sx={{ color: 'error.main', mt: 0.5, fontSize: '12px' }}>
            {phoneError}
          </Typography>
        )}
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography className="yappy-field-label">
          {t(`${T}.AMOUNT_LABEL`)}
        </Typography>
        <Typography className="yappy-amount-value">
          ${Number(paymentData.amount).toFixed(2)}
        </Typography>
      </Box>
    </Box>
  )
}

PaymentInfoCard.propTypes = {
  paymentData: PropTypes.shape({
    customerName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  phoneError: PropTypes.string,
  onPhoneChange: PropTypes.func.isRequired,
}

export default PaymentInfoCard
